const Match = require('@/tbs/model/to/Match')
const match = new Match

/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_MatchRule = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchRule.prototype = {
    /* The view object name */
    name: '',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'match',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getBMMatchRule',
                query: {
                    id: '$matchGroupId,id'
                },
                basePath: 'data.match',
                rule: {
                    id: 'id',
                    status: '$state',
                    teamTotal: '$roundRobinTeamCount',
                    numSelection: '$gameType',
                    type: '$type',
                    specType: '$ruleType,type',
                    /*groupRoundNum: 'matchGroupRoundNum',*/
                    drawRankType: '$teamScoreOrderRule',
                    groupNum: '$roundRobinGroupCount',
                    /*groupNameType: '(1)',*/
                    eliminatedTeamNum: '$knockoutTeamCount',
                    eliminatedRoundNum: '$knockoutRoundCount',
                    roundTotal: '$roundCount,knockoutRoundCount',
                    periodTime: '$semiDuration',
                    periodGapTime: '$halfTimeDuration',
                    pointType: '$winScore,tieScore,loseScore',
                    substitutionType: '$substitutionPlayerCountLimitEnabled,substitutionTotalCountLimitEnabled',
                    restrictionNum: '$substitutionPlayerCountLimit',
                    restrictionNumType: '$substitutionPlayerCountLimitEnabled',
                    restrictionTimes: '$substitutionTotalCountLimit',
                    restrictionTimesType: '$substitutionTotalCountLimitEnabled',
                    isSubstitutionOn: '$substitutionPlayerRecycle',
                    isSubstitutionHalfCount: '$substitutionPlayerHalfCount',
                    substitutionTotal: '$substitutionTotalCountLimit',
                    substitutionTotalType: '$substitutionTotalCountLimitEnabled',
                    substitutionOnceNum: '$substitutionPlayerCountLimit',
                    isSpikeRequired: '$spikeRuleEnabled',
                    isSpikeAGRequired: '$spikeOptions',
                    isSpikeTFRequired: '$spikeOptions',
                    isSpikeMGRequired: '$spikeOptions',
                    isSpikeICRequired: '$spikeOptions',
                    isSpikeHGRequired: '$spikeOptions',
                    isSpikeFGRequired: '$spikeOptions',
                    isSpikeSGRequired: '$spikeOptions',
                    isLegGuardRequired: '$legGuardRequired',
                    isMetalForbidden: '$metalWearAllowed',
                    dataMode: '$eventMode',
                }
            },
            {
                name: 'game',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getBMMatchGameRoundList',
                query: {
                    matchId: '$matchGroupId,id'
                },
                basePath: 'data',
                rule: {
                    gameCount: '$list',
                }
            }
        ],
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateBMMatchRule2',
            basePath: '',
            rule: {
                id: 'id',
                roundRobinTeamCount: 'teamTotal',
                gameType: '$numSelection',
                type: '$type',
                ruleType: '$specType',
                /*matchGroupRoundNum: 'groupRoundNum',*/
                teamScoreOrderRule: '$drawRankType',
                roundRobinGroupCount: 'groupNum',
                /*matchGroupNameType: 'groupNameType',*/
                knockoutTeamCount: 'eliminatedTeamNum',
                knockoutRoundCount: 'eliminatedRoundNum',
                roundCount: '$roundTotal,eliminatedRoundNum',
                semiDuration: 'periodTime',
                halfTimeDuration: 'periodGapTime',
                /*matchPointType: 'pointType',*/
                substitutionPlayerCountLimitEnabled: '$substitutionType,restrictionNumType',
                substitutionTotalCountLimitEnabled: '$substitutionType,restrictionTimesType,substitutionTotalType',
                substitutionPlayerCountLimit: '$substitutionType,restrictionNum,substitutionOnceNum',
                /*matchRestrictionNumType: 'restrictionNumType',*/
                substitutionTotalCountLimit: '$substitutionType,restrictionTimes,substitutionTotal',
                /*matchRestrictionTimesType: 'restrictionTimesType',*/
                substitutionPlayerRecycle: '$isSubstitutionOn',
                substitutionPlayerHalfCount: '$isSubstitutionHalfCount',
                /*matchSubstitutionTotalType: 'substitutionTotalType',*/
                spikeRuleEnabled: '$isSpikeRequired',
                spikeOptions: '$isSpikeAGRequired,isSpikeTFRequired,isSpikeMGRequired,isSpikeICRequired,isSpikeHGRequired,isSpikeFGRequired,isSpikeSGRequired',
                legGuardRequired: '$isLegGuardRequired',
                metalWearAllowed: '$isMetalForbidden',
                eventMode: '$dataMode',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    formatRoundCount: function(roundTotal, eliminatedRoundNum) {
        console.log('@formatRoundCount', roundTotal, eliminatedRoundNum)
        return roundTotal - eliminatedRoundNum
    },
    renderMatchId: function(matchGroupId, id) {
        console.log('@renderMatchId', matchGroupId, id)
        return matchGroupId ? matchGroupId : id
    },
    renderId: function(matchGroupId, id) {
        console.log('@renderId', matchGroupId, id)
        return matchGroupId ? matchGroupId : id
    },
    renderGameCount: function(list) {
        let gameCount = 0
        for (let i = 0; i < list.length; i++) {
            let item = list[i]
            gameCount += item.gameCount
        }
        return gameCount
    },
    renderSubstitutionTotalType: function(substitutionTotalCountLimitEnabled) {
        return substitutionTotalCountLimitEnabled == 2 ? '2' : '1'
    },
    renderRestrictionTimesType: function(substitutionTotalCountLimitEnabled) {
        return substitutionTotalCountLimitEnabled == 2 ? '2' : '1'
    },
    renderRestrictionNumType: function(substitutionPlayerCountLimitEnabled) {
        return substitutionPlayerCountLimitEnabled == 2 ? '2' : '1'
    },
    formatEventMode: function(dataMode) {
        return (Number(dataMode) - 1).toString()
    },
    formatMetalWearAllowed: function(isMetalForbidden) {
        // @specially, use the wrong word from the backend
        return isMetalForbidden == true ? 1 : 0
    },
    formatLegGuardRequired: function(isLegGuardRequired) {
        return isLegGuardRequired == true ? 1 : 0
    },
    formatSpikeOptions: function(isSpikeAGRequired, isSpikeTFRequired, isSpikeMGRequired, isSpikeICRequired, isSpikeHGRequired, isSpikeFGRequired, isSpikeSGRequired) {
        let items = []
        if (isSpikeAGRequired) {
            items.push('1')
        }
        if (isSpikeTFRequired) {
            items.push('2')
        }
        if (isSpikeMGRequired) {
            items.push('3')
        }
        if (isSpikeICRequired) {
            items.push('4')
        }
        if (isSpikeHGRequired) {
            items.push('5')
        }
        if (isSpikeFGRequired) {
            items.push('6')
        }
        if (isSpikeSGRequired) {
            items.push('7')
        }
        if (items.length > 0) {
            return items.join('|')
        }
        return
    },
    formatSubstitutionTotalCountLimit: function(substitutionType, restrictionTimes, substitutionTotal) {
        if (substitutionType == '2') {
            return restrictionTimes
        }
        else if (substitutionType == '4') {
            return substitutionTotal
        }
    },
    formatSubstitutionPlayerCountLimit: function(substitutionType, restrictionNum, substitutionOnceNum) {
        if (substitutionType == '1') {
            return restrictionNum
        }
        else if (substitutionType == '4') {
            return substitutionOnceNum
        }
    },
    formatSpikeRuleEnabled: function(isSpikeRequired) {
        return isSpikeRequired == true ? 1 : 0
    },
    formatSubstitutionPlayerHalfCount: function(isSubstitutionHalfCount) {
        return isSubstitutionHalfCount == true ? 1 : 0
    },
    formatSubstitutionPlayerRecycle: function(isSubstitutionOn) {
        return isSubstitutionOn == true ? 1 : 0
    },
    formatSubstitutionTotalCountLimitEnabled: function(substitutionType, restrictionTimesType, substitutionTotalType) {
        if (substitutionType == '2') {
            if (restrictionTimesType == '1') {
                return 1
            }
            else {
                return 2
            }
        }
        else if (substitutionType == '4') {
            if (substitutionTotalType == '1') {
                return 1
            }
            else {
                return 2
            }
        }
        else {
            return 0
        }
    },
    formatSubstitutionPlayerCountLimitEnabled: function(substitutionType, restrictionNumType) {
        if (substitutionType == '1' || substitutionType == '4') {
            if (restrictionNumType == '1') {
                return 1
            }
            else {
                return 2
            }
        }
        else {
            return 0
        }
    },
    formatTeamScoreOrderRule: function(drawRankType) {
        return Number(drawRankType) - 1
    },
    formatRuleType: function(specType) {
        return match.localeProp('match-spec-type-option-' + specType)
    },
    formatType: function(type) {
        type = type.toString()
        if (type == '1') {
            return 'league'
        }
        else if (type == '2') {
            return 'cup'
        }
    },
    formatGameType: function(numSelection) {
        return match.localeProp('match-number-selection', {num: numSelection})
    },
    renderType: function(type) {
        return (type == 'league') ? '1' : '2'
    },
    renderNumSelection: function(gameType) {
        return gameType.replace(/\D/g, '')
    },
    renderTeamTotal: function(roundRobinTeamCount) {
        return roundRobinTeamCount.toString()
    },
    renderStatus: function(state) {
        state = state || 0
        return (Number(state) + 1).toString()
    },
    renderSpecType: function(ruleType, type) {
        let matchType
        if (type == 'league') {
            matchType = '1'
        }
        else {
            matchType = '2'
        }
        const specTypeOptions = this.getSpecTypeOptions(matchType)
        for (let i = 0; i < specTypeOptions.length; i++) {
            let option = specTypeOptions[i]
            if (option.label == ruleType) {
                return option.value
            }
        }
        return specTypeOptions[0].value
    },
    renderGroupNum: function(roundRobinGroupCount) {
        roundRobinGroupCount = roundRobinGroupCount || 0
        return roundRobinGroupCount.toString()
    },
    renderGroupNameType: function(matchGroupNameType) {
        return matchGroupNameType ? matchGroupNameType : '1'
    },
    renderEliminatedTeamNum: function(knockoutTeamCount) {
        return knockoutTeamCount.toString()
    },
    renderEliminatedRoundNum: function(knockoutRoundCount) {
        return knockoutRoundCount.toString()
    },
    renderRoundTotal: function(roundCount, knockoutRoundCount) {
        console.log('renderRoundTotal', roundCount, knockoutRoundCount)
        return (roundCount + knockoutRoundCount).toString()
    },
    renderDrawRankType: function(teamScoreOrderRule) {
        return (teamScoreOrderRule + 1).toString()
    },
    renderPeriodTime: function(semiDuration) {
        return semiDuration.toString()
    },
    renderPeriodGapTime: function(halfTimeDuration) {
        return halfTimeDuration.toString()
    },
    renderPointType: function(winScore,tieScore,loseScore) {
        if (winScore == 3 && tieScore == 1 && loseScore == 0) {
            return '1'
        }
        else {
            return '2'
        }
    },
    renderSubstitutionType: function(substitutionPlayerCountLimitEnabled, substitutionTotalCountLimitEnabled) {
        if (substitutionPlayerCountLimitEnabled == 0 && substitutionTotalCountLimitEnabled == 0) {
            return '3'
        }
        else if (substitutionPlayerCountLimitEnabled > 0 && substitutionTotalCountLimitEnabled == 0) {
            return '1'
        }
        else if (substitutionPlayerCountLimitEnabled == 0 && substitutionTotalCountLimitEnabled > 0) {
            return '2'
        }
        else {
            return '4'
        }
    },
    renderRestrictionNum: function(substitutionPlayerCountLimit) {
        return substitutionPlayerCountLimit.toString()
    },
    renderRestrictionTimes: function(substitutionTotalCountLimit) {
        return substitutionTotalCountLimit.toString()
    },
    renderIsSubstitutionOn: function(substitutionPlayerRecycle) {
        return substitutionPlayerRecycle === 1
    },
    renderIsSubstitutionHalfCount: function(substitutionPlayerHalfCount) {
        return substitutionPlayerHalfCount === 1
    },
    renderSubstitutionTotal: function(substitutionTotalCountLimit) {
        return substitutionTotalCountLimit.toString()
    },
    renderSubstitutionOnceNum: function(substitutionPlayerCountLimit) {
        return substitutionPlayerCountLimit.toString()
    },
    renderIsSpikeRequired: function(spikeRuleEnabled) {
        return spikeRuleEnabled === 1
    },
    renderIsSpikeAGRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('1') > -1
    },
    renderIsSpikeTFRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('2') > -1
    },
    renderIsSpikeMGRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('3') > -1
    },
    renderIsSpikeICRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('4') > -1
    },
    renderIsSpikeHGRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('5') > -1
    },
    renderIsSpikeFGRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('6') > -1
    },
    renderIsSpikeSGRequired: function(spikeOptions) {
        spikeOptions = spikeOptions || ''
        return spikeOptions.indexOf('7') > -1
    },
    renderIsLegGuardRequired: function(legGuardRequired) {
        return legGuardRequired === 1
    },
    renderIsMetalForbidden: function(metalWearAllowed) {
        // @specially, use the wrong word from the backend
        return metalWearAllowed === 1
    },
    renderDataMode: function(eventMode) {
        return (eventMode + 1).toString()
    },

    matchTypeOptions: [
        { label: match.localeProp('match-type-option-1'), value: '1' },
        { label: match.localeProp('match-type-option-2'), value: '2' },
    ],
    numSelectionOptions: [
        { label: match.localeProp('match-number-selection', {num: 2}), value: '2' },
        { label: match.localeProp('match-number-selection', {num: 3}), value: '3' },
        { label: match.localeProp('match-number-selection', {num: 4}), value: '4' },
        { label: match.localeProp('match-number-selection', {num: 5}), value: '5' },
        { label: match.localeProp('match-number-selection', {num: 6}), value: '6' },
        { label: match.localeProp('match-number-selection', {num: 7}), value: '7' },
        { label: match.localeProp('match-number-selection', {num: 8}), value: '8' },
        { label: match.localeProp('match-number-selection', {num: 9}), value: '9' },
        { label: match.localeProp('match-number-selection', {num: 10}), value: '10' },
        { label: match.localeProp('match-number-selection', {num: 11}), value: '11' },
    ],
    numSelectionIndex: 5,
    drawRankTypeOptions: [
        { label: match.localeProp('draw-rank-type-option-1'), value: '1' },
        { label: match.localeProp('draw-rank-type-option-2'), value: '2' },
        { label: match.localeProp('draw-rank-type-option-3'), value: '3' },
    ],
    groupNameTypeOptions: [
        { label: match.localeProp('group-name-type-option-1'), value: '1' },
        { label: match.localeProp('group-name-type-option-2'), value: '2' },
        { label: match.localeProp('group-name-type-option-3'), value: '3' },
        { label: match.localeProp('group-name-type-option-4'), value: '4' },
    ],
    pointTypeOptions: [
        { label: match.localeProp('point-type-option-1'), value: '1' },
        { label: match.localeProp('point-type-option-2'), value: '2' },
    ],
    substitutionTypeOptions: [
        { label: match.localeProp('substitution-type-option-1'), value: '1' },
        { label: match.localeProp('substitution-type-option-2'), value: '2' },
        { label: match.localeProp('substitution-type-option-3'), value: '3' },
        { label: match.localeProp('substitution-type-option-4'), value: '4' },
    ],
    restrictionNumTypeOptions: [
        { label: match.localeProp('restriction-num-type-option-1'), value: '1' },
        { label: match.localeProp('restriction-num-type-option-2'), value: '2' },
    ],
    restrictionTimesTypeOptions: [
        { label: match.localeProp('restriction-times-type-option-1'), value: '1' },
        { label: match.localeProp('restriction-times-type-option-2'), value: '2' },
    ],
    substitutionTotalTypeOptions: [
        { label: match.localeProp('substitution-total-type-option-1'), value: '1' },
        { label: match.localeProp('substitution-total-type-option-2'), value: '2' },
    ],
    dataModeOptions: [
        { label: match.localeProp('data-mode-option-1'), value: '1' },
        { label: match.localeProp('data-mode-option-2'), value: '2' },
    ],
    getSpecTypeOptions: function(matchType) {
        matchType = matchType ? matchType.toString() : '1'
        if (matchType == '1') {
            return [
                { label: match.localeProp('match-spec-type-option-1'), value: '1' },
                { label: match.localeProp('match-spec-type-option-2'), value: '2' },
            ]
        }
        else if (matchType == '2') {
            return [
                { label: match.localeProp('match-spec-type-option-3'), value: '3' },
                { label: match.localeProp('match-spec-type-option-4'), value: '4' },
                { label: match.localeProp('match-spec-type-option-5'), value: '5' },
            ]
        }
    },

    getSpecType: function(matchType) {
        if (matchType == '1') {
            return '1'
        }
        else if (matchType == '2') {
            return '3'
        }
    },
    getGroupNum: function(matchType, matchSpecType, matchTeamTotal) {
        matchTeamTotal = Number(matchTeamTotal)
        if (matchSpecType == null) {
            matchSpecType = this.getSpecType(matchType)
        }
        if (matchSpecType == '1' || matchSpecType == '2') {
            return 1
        }
        else if (matchSpecType == '3' || matchSpecType == '4') {
            return Math.ceil(matchTeamTotal / 4)
        }
        else if (matchSpecType == '5') {
            return matchTeamTotal
        }
    },
    getEliminatedRoundNum: function(matchEliminatedTeamNum, matchTeamTotal) {
        if (matchEliminatedTeamNum == 0) {
            return 0
        }
        let teamNum = matchEliminatedTeamNum ? Number(matchEliminatedTeamNum) : Number(matchTeamTotal)
        if (teamNum%2 == 1) {
            teamNum += 1
        }
        return teamNum > 2 ? Math.ceil(Math.sqrt(teamNum)) : 1
    },
    getEliminatedTeamNum: function(matchType, matchSpecType, matchTeamTotal) {
        console.log('@getEliminatedTeamNum', matchType, matchSpecType, matchTeamTotal)
        matchTeamTotal = Number(matchTeamTotal)
        if (matchType == '1') {
            return 0
        }
        if (matchSpecType == null) {
            matchSpecType = this.getSpecType(matchType)
        }
        if (matchSpecType == '5') {
            return matchTeamTotal
        }
        else {
            const teamTotal = matchTeamTotal / 2
            let nearestInteger = 0
            let i = 1
            while (nearestInteger <= teamTotal) {
                nearestInteger = Math.pow(2, i++)
            }
            return Math.max(nearestInteger / 2, 2)
        }
    },
    getTotalRoundNum: function(matchTeamTotal, matchType, matchSpecType, matchGroupNum, matchEliminatedTeamNum, matchEliminatedRoundNum) {
        console.log('@@getTotalRoundNum', matchTeamTotal, matchType, matchSpecType, matchGroupNum, matchEliminatedTeamNum, matchEliminatedRoundNum)
        const groupRoundNum = this.getGroupRoundNum(matchTeamTotal, matchType, matchSpecType, matchGroupNum)
        console.log('@groupRoundNum', groupRoundNum)
        if (matchType == '1') {
            return groupRoundNum
        }
        else if (matchType == '2') {
            if (matchEliminatedRoundNum == null) {
                matchEliminatedRoundNum = this.getEliminatedRoundNum(matchEliminatedTeamNum,  matchTeamTotal)
            }
            console.log('@matchEliminatedRoundNum', matchEliminatedRoundNum)
            return groupRoundNum + matchEliminatedRoundNum
        }
    },
    getGroupRoundNum: function(matchTeamTotal, matchType, matchSpecType, matchGroupNum) {
        console.log('@getGroupRoundNum', matchTeamTotal, matchType, matchSpecType, matchGroupNum)
        if (matchSpecType == null) {
            matchSpecType = this.getSpecType(matchType)
        }
        if (matchGroupNum == null) {
            matchGroupNum = this.getGroupNum(matchType, matchSpecType, matchTeamTotal)
        }
        let loopNum = 1
        if (matchType == '1') {           
            if (matchSpecType == '2') {
                loopNum = 2
            }
        }
        else if (matchType == '2') {
            if (matchSpecType == '4') {
                loopNum = 2
            }
            if (matchSpecType == '5') {
                return 0
            }
        }
        console.log('@@', loopNum, matchGroupNum, matchTeamTotal)
        let groupRoundNum
        const groupTeamNum = this.getGroupTeamNum(matchType, matchSpecType, matchTeamTotal, matchGroupNum)
        if (groupTeamNum%2 == 0) {
            groupRoundNum = loopNum * (groupTeamNum - 1)
        }
        else {
            groupRoundNum = loopNum * groupTeamNum
        }
        console.log('@groupRoundNum', groupRoundNum)
        return groupRoundNum
    },
    getGroupTeamNum: function(matchType, matchSpecType, matchTeamTotal, matchGroupNum) {
        if (matchGroupNum == null) {
            matchGroupNum = this.getGroupNum(matchType, matchSpecType, matchTeamTotal)
        }
        // console.log('@getGroupTeamNum', matchTeamTotal, matchGroupNum)
        return Math.ceil(Number(matchTeamTotal) / Number(matchGroupNum))
    },
    getGroupGameCount: function(matchType, matchSpecType, matchTeamTotal, matchGroupNum) {
        // console.log('@getGroupTeamNum', matchTeamTotal, matchGroupNum)
        const groupTeamNum = this.getGroupTeamNum(matchType, matchSpecType, matchTeamTotal, matchGroupNum)
        return Math.ceil(groupTeamNum / 2) * matchGroupNum
    },
    getPeriodTime: function(matchNumSelection) {
        const matchNumSelectionNum = Number(matchNumSelection)
        switch(matchNumSelectionNum) {
            case 11:
                return '45'
            case 10:
                return '45'
            case 9:
                return '30'
            case 8:
                return '30'
            case 7:
                return '20'
            case 6:
                return '25'
            case 5:
                return '25'
            case 4:
                return '30'
            case 3:
                return '10'
            case 2:
                return '12'
        }
    },
    getPeriodGapTime: function(matchNumSelection) {
        const matchNumSelectionNum = Number(matchNumSelection)
        switch(matchNumSelectionNum) {
            case 11:
                return '15'
            case 10:
                return '15'
            case 9:
                return '10'
            case 8:
                return '10'
            case 7:
                return '10'
            case 6:
                return '15'
            case 5:
                return '10'
            case 4:
                return '5'
            case 3:
                return '5'
            case 2:
                return '2'
        }
    },
    getDataModeEventSampleUrl: function() {
        return 'FpmHNeY58vxunCXJj3_0Tcb0qy_S'
    },
    getDataModeStatsSampleUrl: function() {
        return 'Fu61ZPZKUiNiJ4w9MxGup8SL4v25'
    },
}

module.exports = tbs_model_vo_MatchRule